module.exports = __webpack_public_path__ + "img/zombieoffice_17.d6209e06.jpg";